import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type OrderStatus = 'created' | 'new' | 'paid' | 'in_progress' | 'ready' | 'completed' | 'cancelled';

interface OrderStatusBadgeProps {
  status: OrderStatus;
  className?: string;
}

const statusConfig: Record<OrderStatus, { label: string; colorClass: string }> = {
  created: {
    label: 'Ej betald',
    colorClass: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  new: {
    label: 'Ny',
    colorClass: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  paid: {
    label: 'Betald',
    colorClass: 'bg-green-100 text-green-800 border-green-200',
  },
  in_progress: {
    label: 'Pågår',
    colorClass: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  ready: {
    label: 'Redo för upphämtning',
    colorClass: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  },
  completed: {
    label: 'Utlämnad',
    colorClass: 'bg-slate-100 text-slate-700 border-slate-200',
  },
  cancelled: {
    label: 'Avbruten',
    colorClass: 'bg-red-100 text-red-800 border-red-200',
  },
};

export function OrderStatusBadge({ status, className }: OrderStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.new;

  return (
    <Badge variant="outline" className={cn(config.colorClass, className)}>
      {config.label}
    </Badge>
  );
}
